import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgSocialMedia = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 42,
	height: 32,
	viewBox: "0 0 42 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M29 21.773c-1.013 0-1.92.4-2.613 1.027l-9.507-5.533c.067-.307.12-.614.12-.934 0-.32-.053-.626-.12-.933l9.4-5.48A3.983 3.983 0 0 0 29 11c2.213 0 4-1.787 4-4s-1.787-4-4-4-4 1.787-4 4c0 .32.053.627.12.933l-9.4 5.48a3.983 3.983 0 0 0-2.72-1.08c-2.213 0-4 1.787-4 4 0 2.214 1.787 4 4 4 1.053 0 2-.413 2.72-1.08l9.493 5.547c-.066.28-.106.573-.106.867A3.898 3.898 0 0 0 29 29.56a3.898 3.898 0 0 0 3.893-3.893A3.898 3.898 0 0 0 29 21.773z" })
	})
});
export default SvgSocialMedia;
